import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  menuContainer: {
    gap: 15,
    alignItems: 'center',
  },
  menuItem: {
    backgroundColor: '#F8F9FA',
    padding: 16,
    borderRadius: 8,
    width: '100%',
    maxWidth: 400,
    alignItems: 'center',
  },
  menuText: {
    fontSize: 18,
    color: '#333',
  },
  container: {
    flex: 1,
    padding: 16,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 24,
  },

  webOtpContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    maxWidth: 300,
  },

  otpContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 20,
    width: '30%',
  },
  otpInput: {
    width: '100%',
    height: 40,
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    paddingHorizontal: 10,
    marginTop: 10,
    marginBottom: 10,
    textAlign: 'center',
  },
  verifyButton: {
    backgroundColor: '#007AFF',
    padding: 10,
    borderRadius: 5,
    width: '100%',
    alignItems: 'center',
  },
  buttonText: {
    color: '#FFFFFF',
    fontWeight: 'bold',
    fontSize: 16,
  },
  
  // 모바일 환경을 위한 스타일
  mobileOtpContainer: {
    flexDirection: 'column',
    width: '90%',
    marginTop: 20,
  },
  mobileOtpInput: {
    width: '100%',
    height: 50,
    borderWidth: 1,
    borderColor: '#E9ECEF',
    borderRadius: 4,
    paddingHorizontal: 12,
    fontSize: 18,
    marginBottom: 10,
  },
  mobileVerifyButton: {
    backgroundColor: '#2196F3',
    borderRadius: 8,
    width: '100%',
    height: 50,
    alignItems: 'center',
    justifyContent: 'center',
  },
  mobileButtonText: {
    color: '#FFFFFF',
    fontWeight: 'bold',
    fontSize: 18,
  },
});